<div class="container">

    <section class='header'>
        <mat-toolbar color='primary' fxLayoutAlign="space-between">
            <div>
                <mat-icon style='margin-top:10px; font-size:.9em;'>hourglass_top</mat-icon>
                <div style='display:inline-block; margin-left:10px;'>
                   Lista de Espera
                </div>
            </div>

            <button class="button-close" mat-raised-button mat-dialog-close>
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar>
    </section>

    <form class="form" name="entityForm" [formGroup]='entityForm' autocomplete="off">

        <mat-tab-group>
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class='tab-icon'>hourglass_top</mat-icon>
                    <div>Espera</div>
                </ng-template>

                <div class='tab-content-id'>

                    <mat-form-field class="full-width" appearance="fill">
                      <mat-label>Produto</mat-label>
                        <input matInput type="text" [errorStateMatcher]="matcher"
                            [formControl]="entityForm.controls.product_name" autocomplete="off">
                    </mat-form-field>

                    <mat-form-field class="full-width" appearance="fill">
                      <mat-label>Usuário</mat-label>
                        <input matInput type="text" [errorStateMatcher]="matcher"
                            [formControl]="entityForm.controls.member_name"
                             autocomplete="off">
                    </mat-form-field>

                    <mat-form-field class="full-width" appearance="fill">
                      <mat-label>Email</mat-label>
                        <input matInput type="text" [errorStateMatcher]="matcher"
                            [formControl]="entityForm.controls.member_email"
                          autocomplete="off">
                    </mat-form-field>

                    <br>

                    <div>
                        <mat-checkbox color='primary'
                         [formControl]="entityForm.controls.allowed">
                            Liberado
                        </mat-checkbox>
                    </div>

                </div>

            </mat-tab>

        </mat-tab-group>

    </form>

    <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
        <div [ngClass]="{hidden: !spinner}">
            <mat-spinner diameter="30"></mat-spinner>
        </div>

        <button mat-raised-button (click)='update()' [disabled]="entityForm.invalid">
            <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </button>

    </div>

</div>